module.exports = __webpack_public_path__ + "img/biwahonagoya_pc.20827fc3.jpg";